import { Config as ConfigCore } from '@verdaccio/config';
import { authUtils } from '@verdaccio/core';

const { getMatchedPackagesSpec } = authUtils;

class Config extends ConfigCore {
  public constructor(config: any) {
    config.configPath = config.self_path;
    super(config, { forceMigrateToSecureLegacySignature: false });
    // Temporary solution for plugins that depends on legacy configuration files
    this.getMatchedPackagesSpec = (pkgName) => {
      return getMatchedPackagesSpec(pkgName, this.packages);
    };
  }
}

export default Config;
